import React from 'react';
import NotesFeed from '../../../components/ui/NotesFeed';

const NotesTab = ({ siteId, companyId }) => {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-foreground mb-1">Site Notes</h3>
        <p className="text-sm text-muted-foreground">
          Running record of site communication and updates. Use visibility settings to control who can see each note — Private (Admin only), Team (Admin, Site Manager &amp; Workers), or Client Shared (visible in the Client Portal).
        </p>
      </div>
      <NotesFeed
        entityType="site"
        entityId={siteId}
        companyId={companyId}
        title="Site Notes"
      />
    </div>
  );
};

export default NotesTab;
